<template>
  <section>
    <b-modal v-for="popup in popups" :key="popup.id" v-model="popup.is_active">
      <p v-if="popup.type === 'image'" class="image is-4by3 has-text-centered">
        <img class="is-hidden-mobile" :src="popup.src_desktop" />
        <img class="is-hidden-tablet" :src="popup.src_mobile" />
      </p>

      <div class="columns is-gapless" v-if="popup.has_link || popup.has_cancel">
        <div class="column is-1"></div>
        <div class="column has-text-centered" v-if="popup.has_cancel">
          <b-button
            type="is-danger"
            class="mr-2"
            tag="a"
            :href="popup.cancel_url"
            @click="popup.is_active = false"
            >{{ popup.cancel_text }}</b-button
          >
        </div>
        <div class="column has-text-centered" v-if="popup.has_link">
          <b-button
            type="is-dark"
            tag="a"
            :href="popup.link_url"
            @click="popup.is_active = false"
            >{{ popup.link_text }}</b-button
          >
        </div>
        <div class="column is-1"></div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";

export default {

  name: "ModalPopupHandler",
  mixins: [AppMappers],
  props: ["data"],
  data() {
    return {
      popups: [],
    };
  },
  created() {
    this.popups = this.data;
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.popups.forEach((popup) => {
        self.setup(popup);
      });
    });
  },
  methods: {
    setup(popup) {
      let self = this;
      if (popup.has_cookie) {
        if (this.$cookies.isKey(popup.slug) === false) {
          // Is first time
          setTimeout(
            () => (popup.is_active = true),
            popup.delay_seconds * 1000
          );

          let expiration = String(popup.cookie_expiration_unit);

          if (["0", "-1"].includes(expiration) == false) {
            expiration =
              popup.cookie_expiration_time + popup.cookie_expiration_unit;
          }

          if (expiration === "-1") {
            expiration = Infinity;
          }

          console.log("Setting up: ", popup.slug, expiration);

          this.$cookies.set(popup.slug, "ready", expiration);
        }
      }
    },
  },
};
</script>
